import { reactive, ref, watch, computed } from 'vue'
import { APPTHEMECONFIG } from '@/config/constant'
import { Storage } from '@/utils/index'
import { theme } from 'ant-design-vue'

interface IThemeConfig {
  darkMode?: boolean
  primaryColor?: string
}

/** 可切换主题色 */
export const primaryColors = [
  { label: '默认绿', value: '#26bf73', syncHeader: false },
  { label: '极飞红', value: '#a62e21', syncHeader: true },
  { label: '牵牛蓝', value: '#1177b0', syncHeader: true },
  { label: '野菊紫', value: '#525288', syncHeader: true },
  { label: '旧版橙', value: '#e75b11', syncHeader: true },
]

const configStorage = Storage.get<IThemeConfig>(APPTHEMECONFIG)

export const isDarkMode = ref(configStorage?.darkMode || false)
export const primaryColor = ref(configStorage?.primaryColor || primaryColors[0].value)

// 是否同步header颜色
export const syncHeader = computed(() => {
  const item = primaryColors.find((it) => it.value === primaryColor.value)
  if (!item) return true
  return item.syncHeader
})

export const themeConfig = reactive({
  algorithm: theme.defaultAlgorithm,
  token: {},
})

watch(
  isDarkMode,
  (val) => {
    changeDarkMode(val)
  },
  {
    immediate: true,
  }
)

watch(
  primaryColor,
  (val) => {
    changePrimaryColor(val)
  },
  {
    immediate: true,
  }
)

export function changeDarkMode(isDark: boolean) {
  // 添加/移除 dark class
  document.body.classList[isDark ? 'add' : 'remove']('dark')

  themeConfig.algorithm = isDark ? theme.darkAlgorithm : theme.defaultAlgorithm
  saveStorage({ darkMode: isDarkMode.value })
}

export function changePrimaryColor(color: string) {
  // 修改 css 变量
  document.body.style.setProperty('--primary-color', color)

  Object.assign(themeConfig.token, {
    colorPrimary: color,
    colorLink: color,
    colorLinkHover: color,
    colorLinkActive: color,
  })
  saveStorage({ primaryColor: color })
}

function saveStorage(config: IThemeConfig) {
  Storage.set(APPTHEMECONFIG, {
    ...configStorage,
    ...config,
  })
}

/**
 * 获取当前主题的各样式变量
 */
export const getThemeToken = () => theme.useToken().token
